module.exports = __webpack_public_path__ + "static/right-card-e5385d54b058b615c1cfec520d163ec9.png";